<div class="p-4">
    <div class="text-2xl">empty-page works! (This is a catch all for pages that don't exist)</div>
</div>